// stores/organizationStore.js
import { defineStore } from 'pinia'
import { useUserStore } from './userStore'
import * as notificationsApi from '@/api/notificationsApi.js'

export const useNotificationStore = defineStore('notifications', {
    state: () => ({
        notifications: [],
        loading: false,
        error: null,
        _authStore: null,
        _initialized: false
    }),
    getters: {
        isLoading: (state) => state.loading,
        getError: (state) => state.error,
        isInitialized: (state) => state._initialized
    },
    actions: {
        async init() {
            if (this._initialized) return
            
            this._authStore = useUserStore()
            
            try {
                this.loading = true;
                
                await Promise.all([
                    this.fetchAllNotifications()
                ])
                this._initialized = true
            } catch (error) {
                this.error = error
                throw error
            } finally {
                this.loading = false
            }
        },      
        async fetchAllNotifications() {
            if (!this._authStore) this.init()
            try {
                this.loading = true;
                const response = await notificationsApi.getAll(this._authStore.token);
                this.notifications = response;
                return response;
            } catch (error) {
                this.error = error;
                throw error;
            } finally {
                this.loading = false;
            }
        },   
        async readAll() {
            if (!this._authStore) this.init()
            try {
                this.loading = true;
                const response = await notificationsApi.readAll(this._authStore.token);
                // Обновляем локальное состояние, если нужно
                await this.fetchDepartments(this._authStore.token);
                return response;
            } catch (error) {
                this.error = error;
                throw error;
            } finally {
                this.loading = false;
            }
        },
        async readOne(id) {
            if (!this._authStore) this.init()
            try {
                this.loading = true;
                const response = await notificationsApi.readOne(this._authStore.token, id);
                // Обновляем локальное состояние, если нужно
                await this.fetchDepartments(this._authStore.token);
                return response;
            } catch (error) {
                this.error = error;
                throw error;
            } finally {
                this.loading = false;
            }
        }        
    },
})